// extracted by mini-css-extract-plugin
module.exports = {"Container":"Results_Container__3j9la","Sidebar":"Results_Sidebar__2y7a0","Hidden":"Results_Hidden__1s3K2"};